module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-light-gray@2x-049d405be299ed512cfefa09f8ec81d7.png";